module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-FR.ae38827.png";